import axios from "axios";
import { GoogleUser } from "../../stores/AuthStore/types";

interface useGoogleOauthProps {
  onGoogleLogin: (code: string) => void;
}

const clientId = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT;
const clientSecret = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_SECRET;
const redirectUri = "https://app.vekilet.com/oauth2callback";
const scope = "email profile";

const useGoogleOauth = ({ onGoogleLogin }: useGoogleOauthProps) => {
  const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=${encodeURIComponent(scope)}`;

  const nativeLogin = () => {
    window.plugins?.googleplus?.login(
      {
        scopes: scope, // optional, space-separated list of scopes, If not included or empty, defaults to `profile` and `email`.
        webClientId: clientId, // optional clientId of your Web application from Credentials settings of your project - On Android, this MUST be included to get an idToken. On iOS, it is not required.
        offline: true, // optional, but requires the webClientId - if set to true the plugin will also return a serverAuthCode, which can be used to grant offline access to a non-Google server
      },
      (obj: GoogleUser) => {
        console.info(obj);
        onGoogleLogin(obj.accessToken);
      },
      (msg: any) => {
        console.error(msg);
      }
    );
  };

  const handleLogin = () => {
    if (window.plugins?.googleplus) {
      nativeLogin();
      return;
    }

    // Open InAppBrowser for OAuth
    const browser = window.cordova.InAppBrowser.open(
      authUrl,
      "_blank",
      "location=yes"
    );

    browser.addEventListener("loadstart", (event: any) => {
      const url = event.url;

      console.info("Redirecting to page: ", url);

      if (url.startsWith(redirectUri)) {
        // Extract authorization code from URL
        const urlParams = new URLSearchParams(url.split("?")[1]);
        const code = urlParams.get("code");
        if (code) {
          // Close the browser
          browser.close();
          // Exchange code for tokens
          exchangeCodeForToken(code);
        }
      }
    });
  };

  const exchangeCodeForToken = async (code: string) => {
    try {
      const response = await axios.post("https://oauth2.googleapis.com/token", {
        code,
        client_id: clientId,
        client_secret: clientSecret,
        redirect_uri: redirectUri,
        grant_type: "authorization_code",
      });

      const { access_token } = response.data;
      onGoogleLogin(access_token);
    } catch (error) {
      console.error("Token Exchange Error:", error);
    }
  };

  return handleLogin;
};

export default useGoogleOauth;
